<script setup lang="ts">
import { DropdownMenuItem, type DropdownMenuItemProps } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<
    DropdownMenuItemProps & { inset?: boolean; class?: string }
>();
</script>

<template>
    <DropdownMenuItem
        v-bind="props"
        :class="[
            cn(
                'mx-1.5 rounded-lg px-2.5 py-2.5 text-sm font-medium text-iron-500 hover:!bg-iron-100 hover:!text-iron-700 focus:bg-stone-100 focus:text-stone-900 dark:focus:bg-stone-800 dark:focus:text-stone-50 relative flex cursor-default items-center transition-colors outline-none select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
                inset && 'pl-8',
            ),
        ]"
    >
        <slot />
    </DropdownMenuItem>
</template>
